import React, { useState, useEffect } from "react";
import {
    Grid,
    Box,
    Typography,
    MenuItem,
    TextField,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Paper,
    Card,
    FormControl,
    Backdrop,
    CircularProgress,
    Snackbar,
    Autocomplete,
    InputAdornment,

} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Page from 'src/components/Page';
import { createTheme, ThemeProvider } from '@mui/material';
import { Button } from '@material-ui/core';
import axios from 'src/utils/axios';
import Alert from 'src/components/Alert';
import { makeStyles } from '@material-ui/styles';
import ModelSelectorDialog from "src/components/ReceiptQuery/ModelSelectorDialog";
import SearchIcon from "@mui/icons-material/Search";

const theme = createTheme({
    palette: {
        primary: {
            main: '#FF9800',
            light: '#FF9800',
            dark: '#FF9800',
        },
    },
});
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
}));

// const useStyles = makeStyles((theme) => ({
//     stickToBottom: {
//         width: '100%',
//         position: 'fixed',
//         bottom: 0,
//     },
//     root: {
//         minHeight: 500
//     },
//     formControl: {
//         margin: theme.spacing(1),
//         minWidth: 120,
//         maxWidth: 800,
//         minHeight: 500
//     },
//     backdrop: {
//         zIndex: theme.zIndex.drawer + 1,
//         color: '#fff',
//     },
//     container: {
//         maxHeight: 550,
//         minHeight: 550
//     },
//     indentItem: {
//         marginLeft: '20px'
//     }
// }));



const ReceiptQuery = () => {
    const classes = useStyles();

    const [selectedHeader, setSelectedHeader] = useState(0);
    const [selectedFields, setSelectedFields] = useState([]);
    const [criteriaFields, setCriteriaFields] = useState([]);
    const [availableFields, setAvailableFields] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [showCriteria, setShowCriteria] = useState(false);



    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('default');
    const [responseMessage, setresponseMessage] = useState('');


    const [modelSelectorDialogOpen, setModelSelectorDialogOpen] = useState(false);
    const [modelSelectorDialogValueString, setModelSelectorDialogValueString] = useState("");

    useEffect(() => {
        setLoading(true);
        axios.get('GetReciptQueryTitle').then((response) => {
            if (response?.data?.length > 0) {
                setHeaders(response.data);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        setLoading(true);
        axios.get('GetReciptQueryColumns/' + selectedHeader).then((response) => {
            setAvailableFields(response.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    }, [selectedHeader]);

    const [selectedSelectionAreaValue, setSelectedSelectionAreaValue] = useState({ ID: 0 });
    const [selectedCriteriaAreaValue, setSelectedCriteriaAreaValue] = useState({ ID: 0 });
    const [selectedShowAreaValue, setSelectedShowAreaValue] = useState({ ID: 0 });
    const [criteriaValues, setCriteriaValues] = useState([]);
    const [criteriaOptions, setCriteriaOptions] = useState([]);





    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };


    const handleAddField = (field, targetSetter) => {
        targetSetter((prev) => {
            if (!prev.some((item) => item === field)) {
                return [...prev, field];
            }
            return prev;
        });
        if (targetSetter === setCriteriaFields) {
            getQueryCriteriaOptions(field);
        }
    };

    const handleRemoveField = (field, targetSetter) => {
        targetSetter((prev) => prev.filter((item) => item !== field));
    };

    const handleRightArrowClick = (value, targetSetter) => {
        if (targetSetter === setSelectedFields && !value.GOSTERILEBILIR) {
            setUyariTip('error');
            setresponseMessage(`${value.ACIKLAMA} gösterilecek alan olarak seçilemez.`);
            setUyari(true);
            return;
        }
        if (targetSetter === setCriteriaFields && !value.KRITER_OLABILIR) {
            setUyariTip('error');
            setresponseMessage(`${value.ACIKLAMA} kriter alanı olarak seçilemez.`);
            setUyari(true);
            return;
        }
        if (!value || value.ID === 0) {
            console.log("value is empty");
            return;
        }
        handleAddField(value, targetSetter);
        clearSelectedItems();

    }
    const handleLeftArrowClick = (value, targetSetter) => {
        if (!value || value.ID === 0) {
            console.log("value is empty");
            return;
        }
        handleRemoveField(value, targetSetter);
        clearSelectedItems();
    }

    const clearSelectedItems = () => {
        setSelectedSelectionAreaValue({ ID: 0 });
        setSelectedShowAreaValue({ ID: 0 });
        setSelectedCriteriaAreaValue({ ID: 0 });
    }

    const handleSelectedValueClick = (value, targetSetter) => {
        clearSelectedItems();
        if (!value) {
            console.log("value is empty");
            return;
        }
        targetSetter(value);
    }

    const renderCriteria = (field) => {
        switch (field.OBJE_TURU) {
            case "Textbox":
                return (
                    <TextField
                        key={field.ID}
                        label={field.ACIKLAMA}
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={(e) => handleCriteriaChange(e, field)}
                    />
                );
            case "ModelSelectorDialog":
                return (
                    <>
                        <TextField
                            key={field.ID}
                            label={field.ACIKLAMA}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={modelSelectorDialogValueString}
                            onClick={() => setModelSelectorDialogOpen(true)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setModelSelectorDialogOpen(true)}>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <ModelSelectorDialog
                            open={modelSelectorDialogOpen}
                            onClose={() => setModelSelectorDialogOpen(false)}
                            setModelSelectorDialogValueString={setModelSelectorDialogValueString}
                            handleCriteriaChangeValueForMultiSelect={handleCriteriaChangeValueForMultiSelect}
                            field={field}
                        />
                    </>
                );
            case "Select":
                return (
                    <FormControl fullWidth>
                        <TextField
                            select
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={criteriaValues.find((item) => item.ID === field.ID)?.value || ""}
                            onChange={(e) => handleCriteriaChange(e, field)}
                        >
                            {criteriaOptions.find((item) => item.ID === field.ID)?.Options.map((option) => (
                                <MenuItem key={option.Id} value={option.Id}>
                                    {option.Value}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormControl>
                );
            case "AutoComplete":
                return (
                    <Autocomplete
                        size="small"
                        options={criteriaOptions.find((item) => item.ID === field.ID)?.Options || []}
                        getOptionLabel={(option) => option.Value}
                        value={
                            criteriaOptions
                                .find((item) => item.ID === field.ID)
                                ?.Options.find((option) => option.Id === criteriaValues.find((item) => item.ID === field.ID)?.value) || null
                        }
                        onChange={(_, newValue) => handleCriteriaChange({ target: { value: newValue?.Id || "" } }, field)}
                        renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                    />
                );
            default:
                return <></>;
        }
    };

    const handleCriteriaChange = (e, field) => {
        debugger;
        setCriteriaValues((prev) => {
            const index = prev.findIndex((item) => item.ID === field.ID);
            if (index === -1) {
                return [...prev, { ID: field.ID, value: e.target.value, multipleValues: [] }];
            }
            // Yeni bir dizi oluşturarak güncelle
            const newValues = [...prev];
            newValues[index] = { ...newValues[index], value: e.target.value };
            return newValues;
        });
    }

    const handleCriteriaChangeValueForMultiSelect = (value, field) => {
        console.log(value);
        setCriteriaValues((prev) => {
            const index = prev.findIndex((item) => item.ID === field.ID);
            if (index === -1) {
                return [...prev, { ID: field.ID, value: 0, multipleValues: value }];
            }
            prev[index].multipleValues = value;
            return prev;
        });
    }

    const getQueryCriteriaOptions = (field) => {
        if (criteriaFields.some((item) => item.ID === field.ID)) {
            return;
        }
        if (field.OBJE_TURU === "ModelSelectorDialog") {
            setModelSelectorDialogValueString("");
            setModelSelectorDialogOpen(false);
            return;
        }
        setLoading(true);
        axios.get('GetReceiptQueryCreteriaOptions/' + field.ID).then((response) => {
            if (response.data) {
                const data = { ID: field.ID, Options: response.data };
                setCriteriaOptions((prev) => [...prev, data]);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    }


    const createReceiptQuery = () => {
        var displayFields = selectedFields.map((field) => field.ID);
        var criteriaFields = criteriaValues.map((field) => field.ID);
        if (displayFields.length === 0) {
            setresponseMessage("Hiç gösterilecek alan değeri seçmediniz.");
            setUyariTip('error');
            setUyari(true);
            return;
        }
        if (criteriaFields.length === 0) {
            setresponseMessage("Hiç kriter alan değeri seçmediniz.");
            setUyariTip('error');
            setUyari(true);
            return;
        }

        setLoading(true);


        var data = {
            displayFields: displayFields,
            criteriaFields: criteriaFields,
            criteriaValues: criteriaValues
        }
        axios.post('CreateReceiptQuery', data).then((response) => {
            if (response.data) {
                setresponseMessage(response.data.ErrorDescription);
                setUyariTip(response.data.ErrorCode === "0" ? 'success' : 'error');
                setUyari(true);
            }
        }).catch((error) => {
            setresponseMessage("Beklenmeyen bir hata oluştu.");
            setUyariTip('error');
            setUyari(true);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <ThemeProvider theme={theme}>
            <Page>
                <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar
                    open={uyari}
                    autoHideDuration={10000}
                    onClose={uyariKapat}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
                    ></Alert>
                </Snackbar>
                <Card title="Fiş Sorgulama">
                    {/* <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Card >
                                    <CardHeader title="Fiş Başlıkları" />
                                    <Paper style={{ maxHeight: 200, minHeight: 200, overflow: 'auto' }}>
                                        <List className={classes.list} dense component="div" role="list"  >
                                            {headers && headers.map((value) => {
                                                return (
                                                    <ListItem key={value.Id} role="listitem" button
                                                        style={
                                                            selectedHeader === value.Id ? { backgroundColor: '#D1E2E8' } : {}
                                                        }
                                                        onClick={() => setSelectedHeader(value.Id)}
                                                    >
                                                        <ListItemText id={value.Id} primary={value.title} />
                                                    </ListItem>
                                                );
                                            })}
                                            <ListItem />
                                        </List>
                                    </Paper>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <SubCard title="Seçilecek Alanlar">
                                    deneme 123
                                </SubCard>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <SubCard title="Gösterilecek Alanlar">
                                    deneme 123
                                </SubCard>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <SubCard title="Kriter Alanı">
                                    deneme 123
                                </SubCard>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <SubCard title="Kriter Seçim Ekranı">
                            deneme 123
                        </SubCard>
                    </Grid>
                </Grid> */}
                    <Box sx={{ p: 4 }}>
                        <Grid container spacing={3}>
                            {/* Sol Panel */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ height: 100, overflow: "auto" }}>
                                    <Typography variant="h6">Başlıklar</Typography>
                                    <FormControl fullWidth>
                                        <TextField select
                                            variant="outlined"
                                            size='small'
                                            fullWidth
                                            value={selectedHeader}
                                            onChange={(e) => setSelectedHeader(e.target.value)}
                                        >
                                            {headers.map((option) => (
                                                <MenuItem key={option.ID} value={option.ID}>
                                                    {option.BASLIK_ADI}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </Box>
                                <Typography variant="h6" sx={{ mt: 2 }}>
                                    Seçim Alanları
                                </Typography>
                                <Paper variant="outlined" sx={{ height: 450, overflow: "auto" }}>
                                    <List>
                                        {availableFields.length > 0 && availableFields.map((field) => (
                                            <ListItem
                                                key={field.ID}
                                                button
                                                onClick={() => handleSelectedValueClick(field, setSelectedSelectionAreaValue)}
                                                style={
                                                    selectedSelectionAreaValue?.ID === field.ID ? { backgroundColor: '#FF9800' } : {}
                                                }
                                            >
                                                <ListItemText primary={field.ACIKLAMA} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            </Grid>
                            {/* Buton Panel */}
                            <Grid item xs={12} md={1}>
                                <Box sx={{ height: 100, overflow: "auto" }}>
                                </Box>
                                <Typography variant="h6" sx={{ mt: 2, visibility: 'hidden' }}>1</Typography>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    height: 200,
                                    overflow: "auto",
                                    justifyContent: 'center'
                                }}
                                >
                                    <IconButton onClick={() => handleRightArrowClick(selectedSelectionAreaValue, setSelectedFields)}>
                                        <ArrowForwardIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleLeftArrowClick(selectedShowAreaValue, setSelectedFields)}>
                                        <ArrowBackIcon />
                                    </IconButton>
                                </Box>
                                <Typography variant="h6" sx={{ mt: 2, visibility: 'hidden' }}>2</Typography>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    height: 200,
                                    overflow: "auto",
                                    justifyContent: 'center'
                                }}
                                >
                                    <IconButton onClick={() => handleRightArrowClick(selectedSelectionAreaValue, setCriteriaFields)}>
                                        <ArrowForwardIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleLeftArrowClick(selectedCriteriaAreaValue, setCriteriaFields)}>
                                        <ArrowBackIcon />
                                    </IconButton>
                                </Box>
                            </Grid>


                            {/* Orta Panel */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ height: 100, overflow: "auto" }}>
                                </Box>
                                <Typography variant="h6" sx={{ mt: 2 }}>Gösterilecek Alanlar</Typography>
                                <Paper variant="outlined" sx={{ height: 200, overflow: "auto" }}>
                                    <List>
                                        {selectedFields.map((field) => (
                                            <ListItem
                                                key={field.ID}
                                                button
                                                onClick={() => handleSelectedValueClick(field, setSelectedShowAreaValue)}
                                                style={
                                                    selectedShowAreaValue.ID === field.ID ? { backgroundColor: '#FF9800' } : {}
                                                }
                                            >
                                                <ListItemText primary={field.ACIKLAMA} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>

                                <Typography variant="h6" sx={{ mt: 2 }}>
                                    Kriter Alanları
                                </Typography>
                                <Paper variant="outlined" sx={{ height: 200, overflow: "auto" }}>
                                    <List>
                                        {criteriaFields.map((field) => (
                                            <ListItem
                                                key={field.ID}
                                                button
                                                onClick={() => handleSelectedValueClick(field, setSelectedCriteriaAreaValue)}
                                                style={
                                                    selectedCriteriaAreaValue.ID === field.ID ? { backgroundColor: '#FF9800' } : {}
                                                }

                                            >
                                                <ListItemText primary={field.ACIKLAMA} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            </Grid>

                            {/* Sağ Panel */}
                            <Grid item xs={12} md={5}>
                                <Box sx={{ height: 100, overflow: "auto" }}>
                                </Box>
                                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                                    Kriter Seçim Ekranı
                                </Typography>
                                {showCriteria ?
                                    <>
                                        <Grid container spacing={1}>
                                            {criteriaFields.map((field) => (
                                                <Grid item xs={12} key={field.ID}>
                                                    {renderCriteria(field)}
                                                </Grid>
                                            ))
                                            }
                                            <Grid item xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => createReceiptQuery()}
                                                >
                                                    Sorgula
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                    :

                                    (
                                        <>
                                            <Typography variant="body1">
                                                Sık sık yaptığınız sorgulamaları daha kolay yapabilmek için
                                                saklayabilirsiniz. Gösterilecek ve kriter alanlarını seçtikten sonra
                                                <strong> Sakla</strong> butonuna basınız. Açılan pencereye oluşturulan
                                                Şablon için bir isim girin ve Kaydet butonuna basın. Şablonun
                                                kaydedildiğini belirten yazı çıkacaktır.
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => setShowCriteria(true)}
                                                style={{ marginTop: 5 }}>
                                                Kriter Ekranı
                                            </Button>
                                        </>
                                    )}
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
            </Page>
        </ThemeProvider>

    );
};

export default ReceiptQuery;